// Ф7: единый поиск для Cmd+K. Хиты по guests / bookings / properties.
// Простой fan-out по существующим API - нет отдельного backend-endpoint'а.

import { api } from '@smena/ui';

export interface SearchHit {
  type: 'guest' | 'booking' | 'property';
  id: string;
  title: string;
  subtitle?: string;
  href: string;
}

export async function globalSearch(q: string): Promise<SearchHit[]> {
  const query = q.trim();
  if (query.length < 2) return [];
  const [guests, bookings, properties] = await Promise.all([
    api<{ items: Array<{ id: string; name: string | null; phone: string | null }> }>(
      `/api/staff/guests?q=${encodeURIComponent(query)}`,
    ).catch(() => ({ items: [] })),
    api<{ bookings: Array<{ id: string; guestName: string; checkin: string; checkout: string }> }>(
      `/api/staff/bookings`,
    ).catch(() => ({ bookings: [] })),
    api<Array<{ id: string; title: string; city: string | null }>>(
      `/api/staff/properties`,
    ).catch(() => []),
  ]);
  const qLower = query.toLowerCase();
  const hits: SearchHit[] = [];

  for (const g of guests.items) {
    hits.push({
      type: 'guest',
      id: g.id,
      title: g.name ?? 'Гость без имени',
      subtitle: g.phone ?? 'без телефона',
      href: `/clients/${g.id}`,
    });
  }

  for (const b of bookings.bookings) {
    if (!b.guestName.toLowerCase().includes(qLower)) continue;
    hits.push({
      type: 'booking',
      id: b.id,
      title: `${b.guestName} · бронь`,
      subtitle: `${b.checkin} → ${b.checkout}`,
      href: `/bookings/${b.id}`,
    });
  }

  for (const p of properties) {
    if (!p.title.toLowerCase().includes(qLower) && !(p.city ?? '').toLowerCase().includes(qLower)) continue;
    hits.push({
      type: 'property',
      id: p.id,
      title: p.title,
      subtitle: p.city ?? '-',
      href: `/properties/${p.id}`,
    });
  }
  return hits.slice(0, 30);
}
